import { render, staticRenderFns } from "./ProductCargoInfo.vue?vue&type=template&id=56f4e604"
import script from "./ProductCargoInfo.vue?vue&type=script&lang=js"
export * from "./ProductCargoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports